
import { defineComponent, onMounted } from 'vue'

export default defineComponent({
  name: 'ActionFooter',
  components: {},
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    subtitleCount: {
      type: Number
    },
    primaryButtonText: {
      type: String,
      required: true
    },
    primaryButtonCount: {
      type: Number
    },
    primaryButtonUnit: {
      type: String
    },
    secondaryButtonText: {
      type: String,
      required: true
    },
  },
  emits: ['primaryButtonAction', 'secondaryButtonAction'],
  setup (props, { emit }) {

    function primaryButtonAction () {
      emit('primaryButtonAction')
    }

    function secondaryButtonAction () {
      emit('secondaryButtonAction')
    }

    return {
      primaryButtonAction,
      secondaryButtonAction
    }
  },
})
